import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import EllipsisIcon from '../../../Icons/Ellipsis';
import MoreMenuContent from './MoreMenuContent';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import Modal from '../../../Popup/Modal';
import DesktopSharePopup from '../../../SharePopup/DesktopSharePopup/DesktopDeviationSharePopup';
import ActionBarItemWrapper from '../../_partials/ActionBarButton/ActionBarItemWrapper';
import ActionBarButtonOther from '../../_partials/ActionBarButton/ActionBarButtonOther';
import MoreMenuMobileDropdown from './MoreMenuMobileDropdown';
import s from './MoreButton.scss';
export var MoreButton = function (_a) {
    var deviation = _a.deviation;
    var isActionBarButtonRefactorFlagEnabled = useFlag('actionbar_button_refactor');
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), sharePopupVisible = _b[0], setSharePopupVisible = _b[1];
    if (isMobile) {
        return (React.createElement(BiButton, { className: s['mobile-button'] },
            React.createElement(ActionBarIcon, { icon: EllipsisIcon }),
            React.createElement(MoreMenuMobileDropdown, { deviation: deviation })));
    }
    return (React.createElement(React.Fragment, null,
        sharePopupVisible && (React.createElement(Modal, { onRequestClose: function () { return setSharePopupVisible(false); }, isOpen: true },
            React.createElement(DesktopSharePopup, { deviation: deviation }))),
        isActionBarButtonRefactorFlagEnabled ? (React.createElement(ActionBarItemWrapper, { allowMobilePopover: true, placement: isMobile ? 'top-end' : undefined, renderPopover: function (_a) {
                var closeTooltip = _a.closeTooltip;
                return (React.createElement(MoreMenuContent, { deviation: deviation, closeTooltip: closeTooltip, showDesktopDeviationSharePopup: function () { return setSharePopupVisible(true); } }));
            }, tooltip: t('actionbar.more.tooltip') },
            React.createElement(ActionBarButtonOther, null,
                React.createElement(ActionBarIcon, { icon: EllipsisIcon })))) : (React.createElement(ActionBarButton, { allowMobilePopover: true, placement: isMobile ? 'top-end' : undefined, renderPopover: function (_a) {
                var closeTooltip = _a.closeTooltip;
                return (React.createElement(MoreMenuContent, { deviation: deviation, closeTooltip: closeTooltip, showDesktopDeviationSharePopup: function () { return setSharePopupVisible(true); } }));
            }, tooltip: t('actionbar.more.tooltip') },
            React.createElement(ActionBarIcon, { icon: EllipsisIcon })))));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
//# sourceMappingURL=MoreButton.js.map